
  export default {
    mounted() {
      this.el.addEventListener("click", () => {
        const notification = this.el.closest("[role=alert]");
        notification.style.transition = "opacity 200ms ease-in, transform 200ms ease-in";
        notification.style.opacity = "0";
        notification.style.transform = "translateX(1rem)";
        const key = notification.dataset.flashKey;
        setTimeout(() => {
          if (key) this.pushEvent("lv:clear-flash", { key: key });
          notification.remove();
        }, 200);
      });
    }
  }
